module.exports = __webpack_public_path__ + "img/triangle1green.ceb99ac6.png";